<template>
  <div class="registerPage" v-loading="loading" element-loading-text="注册中">
    <div class="top">
      <div class="inner">
        <el-row>
          <el-col :span="16"><p>遵义医科大学附属医院</p></el-col>
          <el-col :span="8"><span>已有登录账号？</span><router-link to="/" class="loginR">登陆</router-link></el-col>
        </el-row>
      </div>
    </div>
    <div class="register">
      <el-card>
        <p>欢迎注册</p>
        <el-divider></el-divider>
        <el-form :model="ruleForm" label-position="top" status-icon :rules="rules" ref="ruleForm" label-width="100px" class="demo-ruleForm">
          <!-- 姓名 -->
          <el-form-item label="姓名" prop="username">
            <el-input v-model="ruleForm.username" placeholder="请输入姓名"></el-input>
          </el-form-item>
          <!-- 密码 -->
          <el-form-item label="密码" prop="pass">
            <el-input type="password" v-model="ruleForm.pass" placeholder="请输入密码" :maxlength="16" autocomplete="off"></el-input>
          </el-form-item>
          <!-- 确认密码 -->
          <el-form-item label="确认密码" prop="checkPass">
            <el-input type="password" v-model="ruleForm.checkPass" placeholder="请输入再次输入密码" autocomplete="off" :maxlength="16"></el-input>
          </el-form-item>
          <!-- 邮箱 -->
          <el-form-item
            prop="email"
            label="邮箱"
            :rules="[
              { required: true, message: '请输入邮箱地址', trigger: 'blur' },
              {
                type: 'email',
                message: '请输入正确的邮箱地址',
                trigger: ['blur']
              }
            ]"
          >
            <el-input placeholder="请输入邮箱" v-model="ruleForm.email"></el-input>
          </el-form-item>
          <!-- 身份证号 -->
          <el-form-item label="身份证号" prop="idCard">
            <el-input v-model="ruleForm.idCard" placeholder="请输入身份证号"></el-input>
          </el-form-item>
          <!-- 手机号 -->
          <el-form-item label="手机号" prop="phone">
            <el-input v-model="ruleForm.phone" placeholder="请输入手机号" :maxlength="11"></el-input>
          </el-form-item>
          <!-- 验证码 -->
          <el-form-item label="手机验证码" prop="yanzheng_code">
            <el-row>
              <el-col :span="6">
                <el-input class="codeInpStyle" v-model="ruleForm.yanzheng_code" placeholder="请输入验证码" :maxlength="6"></el-input>
              </el-col>
              <el-col :span="4" :offset="1">
                <el-button @click="codeHandle" type="primary" :disabled="disableButton">
                  {{ buttonInfo }}
                </el-button>
              </el-col>
            </el-row>
          </el-form-item>
          <!-- 提交 -->
          <el-row class="submitStyle">
            <el-col :span="6">
              <el-button type="primary" @click="submitForm('ruleForm')">确认提交</el-button>
            </el-col>
            <el-col :span="6">
              <el-button @click="resetForm('ruleForm')" type="warning" class="resetBtnStyle">重置</el-button>
            </el-col>
          </el-row>
        </el-form>
      </el-card>
    </div>
  </div>
</template>
<script>
export default {
  name: 'Register',
  data() {
    /**
     * 定义验证规则
     * */

    /**
     * 密码验证
     * */
    var validatePass = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请输入密码'))
      } else {
        if (this.ruleForm.checkPass !== '') {
          this.$refs.ruleForm.validateField('checkPass')
        }
        callback()
      }
    }

    /**
     * 再次确认密码验证
     * */
    var validatePass2 = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请再次输入密码'))
      } else if (value !== this.ruleForm.pass) {
        callback(new Error('两次输入密码不一致!'))
      } else {
        callback()
      }
    }

    /**
     * 手机号验证
     * */
    var validatePhone = (rule, value, callback) => {
      if (!value) {
        return callback(new Error('手机号不能为空'))
      } else {
        const reg = /^1[3-9][0-9]\d{8}$/
        console.log(reg.test(value))
        if (reg.test(value)) {
          callback()
        } else {
          return callback(new Error('请输入正确的手机号'))
        }
      }
    }
    return {
      loading: false,
      disableButton: false,
      buttonInfo: '发送验证码',
      time: 0,
      ruleForm: {
        username: '',
        pass: '',
        checkPass: '',
        idCard: '',
        email: '',
        phone: '',
        yanzheng_code: ''
      },
      rules: {
        username: [
          { required: true, message: '请输入用户名', trigger: 'blur' },
          { min: 1, max: 18, message: '长度在 2 到 18 个字符', trigger: 'blur' }
        ],
        pass: [
          { required: true, validator: validatePass, trigger: 'blur' },
          {
            pattern: /^[a-zA-Z0-9]{6,16}$/,
            message: '密码由6-16位字母或数字组成',
            trigger: 'blur'
          }
        ],
        checkPass: [
          { required: true, validator: validatePass2, trigger: 'blur' },
          {
            pattern: /^[a-zA-Z0-9]{6,16}$/,
            message: '密码由6-16位字母或数字组成',
            trigger: 'blur'
          }
        ],
        idCard: [
          {
            pattern: /(^[1-9]\d{5}(18|19|([23]\d))\d{2}((0[1-9])|(10|11|12))(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx]$)|(^[1-9]\d{5}\d{2}((0[1-9])|(10|11|12))(([0-2][1-9])|10|20|30|31)\d{2}$)/,
            message: '请输入正确的身份证号',
            trigger: 'blur'
          },
          { required: true, message: '请输入身份证号', trigger: 'change' }
        ],
        phone: [{ required: true, validator: validatePhone, trigger: ['blur', 'change'] }],
        yanzheng_code: [{ required: true, message: '请输入验证码', trigger: 'change' }]
      }
    }
  },
  methods: {
    // 倒计时
    timer() {
      if (this.time > 0) {
        this.time--
        this.buttonInfo = this.time + 's后重新获取'
        setTimeout(this.timer, 1000)
      } else {
        this.time = 0
        this.buttonInfo = '发送验证码'
        this.disableButton = false
      }
    },
    // 发送验证码
    codeHandle() {
      this.$refs.ruleForm.validateField('phone', valid => {
        console.log(valid)
        if (valid) {
          this.$message({
            type: 'warning',
            message: '请先填写正确的手机号',
            offset: 300
          })
        } else {
          console.log('ok')
          // 发请求
          const params = {
            tel: this.ruleForm.phone
          }
          this.$axios
            .get('api/sms/SendSmsCode', {
              params: params
            })
            .then(result => {
              // 已发
              console.log(result)
              this.$message({
                type: 'success',
                message: '验证码已发送您的手机，60s后可再次发送，请注意查收',
                offset: 300
              })
              this.disableButton = true
              this.time = 60
              this.timer()
              // setTimeout(() => {
              //   this.disableButton = false
              // }, 60000)
              console.log('发送验证码')
            })
        }
      })
    },
    // 提交表单
    submitForm(formName) {
      this.$refs[formName].validate(valid => {
        console.log(valid)
        if (!valid) return
        this.loading = true
        const params = {
          userName: this.ruleForm.username,
          password: this.ruleForm.pass,
          password2: this.ruleForm.checkPass,
          email: this.ruleForm.email,
          idcard: this.ruleForm.idCard,
          tel: this.ruleForm.phone,
          smsCode: this.ruleForm.yanzheng_code
        }
        this.$axios
          .post('/api/user/register', {...params})
          .then(result => {
            const { data: res } = result
            if (res.response_code == 200) {
              this.$message({
                message: '注册成功,即将返回登录页面',
                type: 'success',
                offset: '300'
              })
              this.$router.push('/')
              this.$refs.ruleForm.resetFields()
            } else {
              this.loading = false
              this.$message({
                message: res.response_msg,
                type: 'error',
                offset: '300'
              })
            }
          })
          .catch(err => {
            console.log(err)
            this.loading = false
            this.$message({
              message: '服务器连接失败，请重试',
              type: 'error',
              offset: '300'
            })
          })
      })
    },
    // 重置表单
    resetForm(formName) {
      this.$refs[formName].resetFields()
    }
  }
}
</script>
<style lang="scss" scoped>
@import '../assets/style/mixin.scss';
.registerPage {
  .top {
    background-color: #086167;
    margin-bottom: 50px;
    .inner {
      @include autoInner();
      color: #fff;
      padding: 40px 0;
      p {
        font-size: 32px;
      }
      .loginR {
        color: #409eff;
      }
    }
  }
  .register {
    @include autoInner();
    .el-card__body {
      p {
        font-size: 24px;
      }
      .el-form {
        padding: 0 150px;
        .el-input {
          width: 60%;
        }
        .submitStyle {
          margin-top: 80px;
          .el-button {
            width: 150px;
          }
        }
        .codeInpStyle {
          width: 100%;
        }
      }
    }
  }
}
</style>
